module.exports = __webpack_public_path__ + "media/PAG88-07.73033768.mp3";